import { useContext } from 'react';
import { PermissionedRoute } from 'types';
import createNamedContext from 'utils/createNamedContext';

const PermissionRouteConfigContext = createNamedContext<{
  routes?: PermissionedRoute[];
  mainRoutes?: PermissionedRoute[];
}>('RouteConfig', {
  routes: undefined,
  mainRoutes: undefined,
});

export const PermissionRouteConfigProvider = PermissionRouteConfigContext.Provider;

export const usePermissionRouteConfig = () => {
  return useContext(PermissionRouteConfigContext);
};
